module.exports = __webpack_public_path__ + "static/media/companydefaultOld.ddefb309.jpg";